const filterUrlParams = {
  encode: (obj: { [key in string]: string }) => {
    return Object.entries(obj)
      .reduce((result, [key, value]) => {
        result.push(`${key}-${value.replace(/,/g, ".")}`);
        return result;
      }, [])
      .join("~");
  },
  decode: (str: string): { [key in string]: string } => {
    return str.split("~").reduce((result, item) => {
      const arr = item.split("-");
      if (arr[0] && arr[1]) {
        result[arr[0]] = arr[1].replace(/\./g, ",");
      }
      return result;
    }, {});
  },
};

export default filterUrlParams;
